import { useCareLogger } from '@backmarket/nuxt-layer-care-platform/useCareLogger'
import type { SalesCustomerCareScope } from '@backmarket/nuxt-layer-care-platform/useCareLogger/config'

export interface IssuesCommunication {
  selectedIssues: string[]
  tags: string[]
}

interface encodeIssuesParams {
  issues: IssuesCommunication
  scope: SalesCustomerCareScope
}

interface decodeIssuesParams {
  issuesBase64String: string
  scope: SalesCustomerCareScope
}

export function encodeIssues({ issues, scope }: encodeIssuesParams) {
  const { logError } = useCareLogger()

  try {
    const json = JSON.stringify(issues)
    const base64 = btoa(json)

    return base64
  } catch (error) {
    logError({
      errorTitle: `${scope} Error occured when encoding issues`,
      errorDetail: {
        issues,
        error: error as Error,
      },
      errorType: 'customer_issues_communication',
    })

    throw error
  }
}

export function decodeIssues({
  issuesBase64String,
  scope,
}: decodeIssuesParams) {
  const { logError } = useCareLogger()

  try {
    const rawString = atob(issuesBase64String)
    const json: IssuesCommunication = JSON.parse(rawString)

    return json
  } catch (error) {
    logError({
      errorTitle: `${scope} Error occured when decoding issues`,
      errorDetail: {
        issues: issuesBase64String,
        error: error as Error,
      },
      errorType: 'customer_issues_communication',
    })

    throw error
  }
}
